<template>
  <div>
    <van-image width="100%" height="36vw" fit="cover" :src="require('../../assets/image/deatop.jpg')"/>
    <div class="q_enter">
      <div class="q_pad_lr15px">
        <div class="q_pad_15px q_back_white q_bor_5 q_mar_b15px">
          <div class="q_text_m q_bold q_justify">{{ firm.name }}</div>
          <div class="q_text_s q_color_gray q_mar_t10px">{{ firm.address }}</div>
          <div class="q_text_s q_color_gray q_mar_t3px">{{ firm.phone }}</div>
        </div>
        <div class="q_pad_15px q_back_white q_bor_5 q_mar_b15px">
          <div class="q_text_m q_bold">企业介绍</div>
          <div class="q_text_m q_mar_t10px q_enter_con">
            <p v-html="firm.introduce"></p>
          </div>
        </div>

        <div class="q_pad_15px q_back_white q_bor_5 q_mar_b15px">

          <div class="q_text_m q_bold">点赞列表<span class="q_flo_right q_text_s q_color_gray q_mar_t3px"
                                                     style="font-weight: 400;">共{{ firm.praiseCount + firm.praise }}位志愿者点赞</span>
            <div style="clear: both"></div>
          </div>
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
            <van-list
                v-model:loading="loading"
                :finished="finished"
                :immediate-check="false"
                finished-text="没有更多了"
                @load="onLoad"
                error-text="请求失败，点击重新加载"
            >
              <div class="q_mar_t10px q_vertical_left" v-for="item in list">
                <van-image fit="cover" :src="item.avatar" class="q_enter_pic q_flo_left"/>
                <span class="q_flo_left q_moit1 q_mar_l10px" style="width: 30vw;">{{ item.userName }}</span>
                <span class="q_inlineblock q_text_s q_color_gray q_right"
                      style="width: 40vw;">{{ item.createTime }}</span>
              </div>
            </van-list>
          </van-pull-refresh>
          <!--空数据-->
          <div class="q_center" style="margin: 3vh 0;" v-if="showEmpty">
            <img src="@/assets/image/none.png" style="width: 26vw;"/>
            <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
          </div>
        </div>

        <div style="height: 16vw;"></div>
      </div>
    </div>
    <van-goods-action>
      <van-goods-action-button type="danger" color="#FF5733" @click="praise" text="为企业点赞"/>
    </van-goods-action>
  </div>
</template>

<script>
import {getFirm} from "@/api/firm";
import {addUserFirm, listUserFirm} from "@/api/userFirm";
import {Dialog} from "vant";

export default {
  name: 'Enterdea',
  props: {
    msg: String
  },
  data() {
    return {
      //企业id
      firmId: '',
      firm: {},
      showEmpty: false,
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      pageParam: {
        pageNum: 0,
        pageSize: 5,
        firmId: this.$route.query.id
      }
    }
  },
  created() {
    this.firmId = this.$route.query.id
    getFirm(this.$route.query.id).then((res) => {
      this.firm = res.data
    })
    this.onRefresh()
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam.pageNum = 0
      this.pageParam.pageSize = 5
      this.list = []
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询企业点赞信息列表
      listUserFirm(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        } else {
          this.showEmpty = false
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          this.list.push(res.rows[i]);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    //点赞
    praise() {
      var param = {
        firmId: this.firmId
      }
      addUserFirm(param).then((res) => {
        if (res.code == 200) {
          Dialog.alert({
            message: '点赞成功',
            theme: 'round-button',
          }).then(() => {
            this.onRefresh()
          })
        }
      })
    }
  },
}
</script>
<style scoped="scoped">
.q_enter {
  position: absolute;
  top: 30vw;
  left: 0;
  width: 100%;
  min-height: calc(100vh - 30vw);
  background: linear-gradient(0deg, rgba(245, 162, 144, 1) 0%, rgba(245, 162, 144, 0) 100%);;
}

.q_enter_con p {
  margin-bottom: 10px;
}

.q_enter_pic {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}

.q_enter_pic >>> .van-image__img {
  border-radius: 20px;
}

>>> .van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}
</style>
